
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/boot/initializers/jst/incompleteRegistrationWarning';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div style=\"margin:1em 2em;font-size:1.1em\">\n  <p>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'email': ((depth0 && depth0.email)),
    'w0': ("<b>$1</b>"),
    'i18n_scope': ("registration.incomplete_registration_warning")
  },data:data},helper ? helper.call(depth0, "registration.incomplete_registration_warning.set_up_account", "Your account is almost set up. To finish, please check your email at *%{email}* to set your password.", options) : helperMissing.call(depth0, "t", "registration.incomplete_registration_warning.set_up_account", "Your account is almost set up. To finish, please check your email at *%{email}* to set your password.", options)))
    + "\n  </p>\n  <p>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("registration.incomplete_registration_warning")
  },data:data},helper ? helper.call(depth0, "registration.incomplete_registration_warning.start_participating", "You can start participating now, but you must set a password before you can log back in.", options) : helperMissing.call(depth0, "t", "registration.incomplete_registration_warning.start_participating", "You can start participating now, but you must set a password before you can log back in.", options)))
    + "\n  </p>\n</div>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  